import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/website/mercari/`;

const addAuctionItem = async (payload) => {
  return await axios.post(API_URL + "auction", payload);
};

const updateAuctionItem = async (payload) => {
  return await axios.post(API_URL + "auction/update", payload);
};

const getAuctionItemsByFinishDate = async (payload) => {
  return await axios.post(API_URL + "auction/list", payload);
};

const setAuctionItemStatus = async ({ id, status }) => {
  return await axios.post(API_URL + "auction/status", { id, status });
};

const getAuctionAttentionItems = async (shop) => {
  return await axios.post(API_URL + "auction/attention", { shop });
};

const claimAuctionCase = async ({ id, takeover, shop }) => {
  return await axios.post(API_URL + "auction/claim", { id, takeover, shop });
};

const releaseAuctionCase = async (id) => {
  return await axios.post(API_URL + "auction/release", { id });
};

const cancelAuctionItem = async (id) => {
  return await axios.post(API_URL + "auction/cancel", { id });
};

const getPendingChanges = async (shop) => {
  return await axios.post(API_URL + "changes", shop);
};

const takeCase = async (changeId) => {
  return await axios.post(API_URL + `changes/take/`, {changeId});
};

const completeCase = async (formData) => {
  return await axios.post(API_URL + `changes/complete/`, formData);
};

const getMercariChangeClaimCounts = async (shop) => {
  return await axios.post(API_URL + `changes/claim-counts`, { shop });
};

const getNegotiationLists = async (shop, page = 1, limit = 50, showHiddenItems = false) => {
  return await axios.post(API_URL + 'negotiation-lists', {
    shop,
    page,
    limit,
    showHiddenItems
  });
};

// Who asked for a discount on this item link (both platform and chat flows).
const lookupNegotiationsByItem = async (item) => {
  return await axios.get(API_URL + 'negotiation/by-item', { params: { item } });
};

const addNegotiation = async (formData) => {
  return await axios.post(API_URL + 'manual-negotiation', formData);
};

const untrackNegotiation = async (favoriteId, shop, url = null) => {
  return await axios.post(API_URL + 'negotiation/untrack', {
    favoriteId,
    shop,
    url
  });
};

const updateNegotiationCustomer = async (favoriteId, customerId) => {
  return await axios.post(API_URL + 'negotiation/update-customer', {
    favoriteId,
    customerId
  });
};

const getDashboardItems = async () => {
  return await axios.get(API_URL + "admin/dashboard");
};

const getMercariAccounts = async () => {
  return await axios.get(API_URL + "admin/accounts");
};

// keyData banner pair: unclaimed + mine across the three Mercari-admin case types
// (purchase, price negotiation, receipt approval), scoped to the currently
// selected shop (like the beam / receipt / cancel banners).
const getMercariAdminClaimCounts = async (shop) => {
  return await axios.post(API_URL + "admin/claim-counts", { shop });
};

export default {
  takeCase,
  addAuctionItem,
  updateAuctionItem,
  getAuctionItemsByFinishDate,
  setAuctionItemStatus,
  getAuctionAttentionItems,
  claimAuctionCase,
  releaseAuctionCase,
  cancelAuctionItem,
  getPendingChanges,
  completeCase,
  getMercariChangeClaimCounts,
  getNegotiationLists,
  lookupNegotiationsByItem,
  addNegotiation,
  untrackNegotiation,
  updateNegotiationCustomer,
  getDashboardItems,
  getMercariAccounts,
  getMercariAdminClaimCounts
};
